"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styled_components_1 = __importDefault(require("styled-components"));
var polished_1 = require("polished");
var colors_1 = require("../util/colors");
var hooks_1 = require("../util/hooks");
var scroll_1 = require("../util/scroll");
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var Button_1 = __importDefault(require("./Button"));
var IconButton_1 = __importDefault(require("./IconButton"));
var layout_1 = require("../util/layout");
var Overlay = (0, styled_components_1.default)(grid_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n"], ["\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n"])), (0, polished_1.rgba)(colors_1.colors.gray200, 0.5));
var bigWidth = '576px';
var lilWidth = '320px';
var sizeRules = function (_a) {
    var size = _a.size;
    switch (size) {
        case 'big':
            return "\n  @media (max-width: ".concat(bigWidth, ") {\n    height: 100%;\n    width: 100vw;\n  }\n\n  @media (min-width: ").concat(bigWidth, ") {\n    max-height: calc(100% - 2rem);\n    width: ").concat(bigWidth, ";\n    border-radius: 8px;\n  }\n");
        case 'small':
            return "\n  max-height: calc(100% - 2rem);\n  border-radius: 8px;\n\n  @media (max-width: ".concat(lilWidth, ") {\n    width: 100vw;\n  }\n\n  @media (min-width: ").concat(lilWidth, ") {\n    width: ").concat(lilWidth, ";\n  }\n\n");
        case 'full':
            return "\n  height: 100%;\n  width: 100vw;\n";
    }
};
var ModalWrapper = (0, styled_components_1.default)(grid_1.Container)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0px 16px 24px rgba(41, 40, 39, 0.1);\n\n  flex-wrap: nowrap;\n  overflow: hidden;\n\n  @keyframes slide-modal-in {\n    0% {\n      opacity: 0;\n    }\n    1% {\n      opacity: 1;\n      transform: translateY(200%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n  }\n\n  ", "\n\n  ", "\n"], ["\n  background-color: ", ";\n  box-shadow: 0px 16px 24px rgba(41, 40, 39, 0.1);\n\n  flex-wrap: nowrap;\n  overflow: hidden;\n\n  @keyframes slide-modal-in {\n    0% {\n      opacity: 0;\n    }\n    1% {\n      opacity: 1;\n      transform: translateY(200%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n  }\n\n  ", "\n\n  ", "\n"])), colors_1.colors.white, function (_a) {
    var animate = _a.animate, animateDelay = _a.animateDelay;
    return animate
        ? "\n  animation-duration: 500ms;\n  animation-name: slide-modal-in;\n  animation-fill-mode: both;\n  animation-delay: ".concat(animateDelay || '0s', ";\n")
        : '';
}, sizeRules);
var AnimateH3 = (0, styled_components_1.default)(typography_1.H3)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transition: opacity ease 250ms;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  transition: opacity ease 250ms;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var Contents = (0, styled_components_1.default)(spacing_1.Div)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: auto;\n  flex-grow: 1;\n  padding-bottom: ", ";\n"], ["\n  overflow: auto;\n  flex-grow: 1;\n  padding-bottom: ", ";\n"])), (0, layout_1.space)(2.5));
var Footer = (0, styled_components_1.default)(spacing_1.Div)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  box-shadow: 0px 0px 8px rgba(41, 40, 39, 0.1);\n  background-color: ", ";\n  padding: ", ";\n  margin-top: ", ";\n"], ["\n  box-shadow: 0px 0px 8px rgba(41, 40, 39, 0.1);\n  background-color: ", ";\n  padding: ", ";\n  margin-top: ", ";\n"])), colors_1.colors.white, (0, layout_1.space)(2), (0, layout_1.space)(2.5));
var Modal = function (_a) {
    var open = _a.open, back = _a.back, titleText = _a.titleText, submitText = _a.submitText, submitColor = _a.submitColor, cancelText = _a.cancelText, onSubmit = _a.onSubmit, onCancel = _a.onCancel, onDismiss = _a.onDismiss, children = _a.children, renderFooter = _a.renderFooter, banner = _a.banner, headerCenterContent = _a.headerCenterContent, _b = _a.noPadding, noPadding = _b === void 0 ? false : _b, _c = _a.animate, animate = _c === void 0 ? false : _c, animateDelay = _a.animateDelay, _d = _a.submitDisabled, submitDisabled = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? 'big' : _e, _f = _a.fullWidthFooter, fullWidthFooter = _f === void 0 ? false : _f, _g = _a.overlayProps, overlayProps = _g === void 0 ? {} : _g, _h = _a.dismissWithCloseButton, dismissWithCloseButton = _h === void 0 ? false : _h;
    var _j = (0, react_1.useState)(false), titleVisible = _j[0], setTitleVisible = _j[1];
    var rootElemRef = (0, react_1.useRef)();
    var isMobileViewport = (0, hooks_1.useBreakpoint)('sm');
    (0, react_1.useEffect)(function setupElement() {
        rootElemRef.current = document.createElement('div');
        var parentElem = document.querySelector('body');
        parentElem.appendChild(rootElemRef.current);
        return function () { return rootElemRef.current.remove(); };
    }, []);
    (0, react_1.useEffect)(function () {
        if (!open)
            return;
        var body = document.querySelector('body');
        var oldOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return function () {
            document.querySelector('body').style.overflow = oldOverflow;
        };
    }, [open]);
    var _k = (0, scroll_1.useScrollPosition)(function (pos) {
        if (!pos.visible && !titleVisible) {
            setTitleVisible(true);
        }
        else if (pos.visible && titleVisible) {
            setTitleVisible(false);
        }
    }, [titleVisible, setTitleVisible]), scrollRegionRef = _k.scrollRegionRef, titleRef = _k.watchElementRef;
    if (!open)
        return null;
    var dismiss = function () {
        onDismiss && onDismiss();
    };
    var footer = null;
    var inlineFooterContents = null;
    if (renderFooter) {
        var inner_1 = renderFooter();
        footer = inner_1 ? react_1.default.createElement(Footer, null, inner_1) : null;
    }
    else if (onCancel || onSubmit) {
        var big = size !== 'small';
        var cancelButton = onCancel ? (react_1.default.createElement(Button_1.default, { secondary: true, onClick: onCancel, name: "Cancel", style: big ? {} : { minWidth: '110px' }, fullWidth: fullWidthFooter }, cancelText)) : null;
        var submitButton = onSubmit ? (react_1.default.createElement(spacing_1.Div, { pl: cancelButton && big && !fullWidthFooter ? 2 : 0, pt: fullWidthFooter && cancelButton ? 2 : 0, style: { minWidth: fullWidthFooter ? '100%' : 'auto' } },
            react_1.default.createElement(Button_1.default, __assign({ onClick: onSubmit, disabled: submitDisabled, name: "Submit", fullWidth: fullWidthFooter }, __assign({}, (submitColor && { color: submitColor })), { style: big ? {} : { minWidth: '110px' } }), submitText))) : null;
        if (big) {
            footer = (react_1.default.createElement(Footer, null,
                react_1.default.createElement(grid_1.Container, { justify: "flex-end", align: "center", direction: fullWidthFooter ? 'column' : 'row' },
                    cancelButton,
                    submitButton)));
        }
        else {
            inlineFooterContents = (react_1.default.createElement(grid_1.Container, { py: 3, justify: "space-around" },
                cancelButton,
                submitButton));
        }
    }
    var headerBorder = size === 'full' && !isMobileViewport;
    var TitleComponent = size === 'full' ? typography_1.H2 : typography_1.H3;
    var inner = (react_1.default.createElement(react_1.default.Fragment, null,
        titleText ? (react_1.default.createElement(TitleComponent, { weight: size === 'full' ? 700 : 600, pt: size === 'small' || headerBorder ? 3 : 0, pb: 3, ref: titleRef }, titleText)) : ((size === 'small' || headerBorder) && react_1.default.createElement(spacing_1.Div, { pb: 3 })),
        children,
        inlineFooterContents));
    if (!rootElemRef.current)
        return null;
    return react_dom_1.default.createPortal(react_1.default.createElement(Overlay, __assign({ center: true }, overlayProps, { onClick: function (e) {
            e.stopPropagation();
            if (dismissWithCloseButton)
                return;
            dismiss();
        } }),
        react_1.default.createElement(ModalWrapper, __assign({ size: size, direction: "column", onClick: function (e) { return e.stopPropagation(); } }, { animate: animate, animateDelay: animateDelay }),
            size !== 'small' && (react_1.default.createElement(grid_1.Container, { px: 3, py: 2, wrap: false, bb: headerBorder, justify: headerCenterContent ? 'space-between' : 'flex-start', align: "center" },
                react_1.default.createElement(grid_1.Container, { align: "center", justify: "flex-start", style: __assign({ overflow: 'hidden' }, (headerCenterContent && { width: '30%' })), wrap: false },
                    react_1.default.createElement(IconButton_1.default, { icon: back ? 'back' : 'close', name: "Close", onClick: dismiss }),
                    !back && size === 'full' && !isMobileViewport && (react_1.default.createElement(spacing_1.Div, { onClick: dismiss, style: { cursor: 'pointer' }, pl: 1 },
                        react_1.default.createElement(typography_1.P, null, "Close"))),
                    back && (react_1.default.createElement(spacing_1.Div, { onClick: dismiss, style: { cursor: 'pointer' }, pl: 1 },
                        react_1.default.createElement(typography_1.P, null, "Back"))),
                    titleText && (react_1.default.createElement(AnimateH3, { weight: 600, pl: 3, style: { opacity: titleVisible ? 1 : 0 } }, titleText))),
                headerCenterContent && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(grid_1.Container, { center: true }, headerCenterContent),
                    react_1.default.createElement(grid_1.Container, { style: { width: '30%' } }))))),
            react_1.default.createElement(Contents, { ref: scrollRegionRef },
                banner ? banner : null,
                size === 'full' && !noPadding ? (react_1.default.createElement(grid_1.LayoutWrapper, null, inner)) : (react_1.default.createElement(spacing_1.Div, { px: noPadding ? 0 : 3 }, inner))),
            footer)), rootElemRef.current);
};
exports.default = Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Modal.js.map